import { HiMenu } from "react-icons/hi";
import IconButton from "../../IconButton";
import { useEffect, useState } from "react";
import { Loader, Popup } from "semantic-ui-react";
import { getLenders } from "../../../actions/lender";
import useBreakpoint from "@restart/hooks/useBreakpoint";
import { FcAdvertising, FcCancel, FcOk } from "react-icons/fc";

interface AllLendersProps {
  setOpen: (value: boolean) => void;
}

function AllLenders({ setOpen }: AllLendersProps) {
  const isSmall = useBreakpoint("sm", "down");
  const [lenders, setLenders] = useState([]);

  useEffect(() => {
    getLenders()
      .then((result) => setLenders(result.data.results))
      .catch((e) => {});
  }, []);

  if (!lenders) {
    <Loader />;
  }

  return (
    <>
      <main
        className="flex-grow bg-gray-50 text-gray-900"
        // style={{ height: "150vh" }}
      >
        {isSmall && (
          <header className="flex items-center justify-between px-4 py-4">
            <IconButton className="-ml-2" onClick={() => setOpen(true)}>
              <HiMenu />
            </IconButton>
          </header>
        )}
        <div className="p-6">
          <div className="flex items-center justify-between">
            <div className="font-semibold text-xl">All Lenders</div>
          </div>

          <div className="py-6">
            <div className="rounded-xl shadow-sm bg-white md:col-span-12">
              <div className="p-4 overflow-x-scroll">
                <table className="min-w-full">
                  <thead className="text-sm bg-gray-50 text-gray-500">
                    <tr className="text-sm text-left">
                      <th className="px-4 py-3 whitespace-nowrap">ID</th>
                      <th className="px-4 py-3 whitespace-nowrap">Name</th>
                      <th className="px-4 py-3 whitespace-nowrap">Status</th>
                      <th className="px-4 py-3 whitespace-nowrap">Amount</th>
                      <th className="px-4 py-3 whitespace-nowrap">Actions</th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {lenders ? (
                      lenders.map((lender: any) => (
                        <tr className="text-sm text-left">
                          <td className="px-4 py-3 whitespace-nowrap">
                            {lender.id}
                          </td>
                          <td className="px-4 py-3 whitespace-nowrap">
                            {lender.name}
                          </td>
                          <td className="px-4 py-3 whitespace-nowrap">
                            <span className="inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-600/20">
                              Active
                            </span>
                          </td>
                          <td className="px-4 py-3 whitespace-nowrap">
                            <span className="font-bold">$ 2500</span>
                          </td>
                          <td className="px-4 py-3 whitespace-nowrap">
                            <div className="flex gap-1 text-xl">
                              <Popup
                                content={"Send an Update Request"}
                                trigger={<FcAdvertising />}
                              />
                              <Popup
                                content={"Deactivate Lender"}
                                trigger={<FcCancel />}
                              />
                              <Popup
                                content={"Activate Lender"}
                                trigger={<FcOk />}
                              />
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <div className="w-full mx-auto text-center py-6">
                        No Lenders
                      </div>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
}

export default AllLenders;
